import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { IGroup } from 'src/app/interfaces/group';
import { UserApiService } from '../../services/user-api.service';
import moment from 'moment';

@Component({
    selector: 'edit-groups',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class EditGroups implements OnInit {
  @Input() role: string;
  @Input() userId: number;
  public filteredGroups: any = [];
  public userGroups = new BehaviorSubject<Array<IGroup>>([]);
  myControl = new FormControl('');

  constructor(
    private UserApi: UserApiService,
    private ActivatedRoute: ActivatedRoute
  ) {}

  debounce(func, wait) {
    let timeout;

    return (...args) => {
      const later = () => {
        timeout = null;
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  ngOnInit(): void {
    this.userId = this.ActivatedRoute.snapshot.params['userId'];
    this.getUserGroups();
    this.setFilteredGroups();
  }

  setFilteredGroups() {
    this.myControl.valueChanges.subscribe((value) => {
      if (value && value.length > 2) {
        this.filterOptionsDebounce(value);
      }
    });
  }

  filterOptionsDebounce = this.debounce(this.filterOptions.bind(this), 300);

  async filterOptions(value) {
    const values = await this.UserApi.getFilteredGroups(
      { searchString: value },
      this.role
    );
    if (values && values['data']) {
      this.filteredGroups = values.data.filter((group) => {
        return !this.userGroups.value.some((userGroup) => {
          return userGroup.id === group.id;
        });
      });
    }
  }

  async getUserGroups() {
    const data = await this.UserApi.getUserGroups(this.userId, '', this.role);
    const activeGroups = data.data.filter(
      (group) =>
        group.end > moment().format('YYYY-MM-DD HH:mm:ss') || group.end === null
    );
    this.userGroups.next(activeGroups);

    this.setFilteredGroups();
  }

  async deleteItem(group) {
    const { id } = group;
    await this.UserApi.deleteGroup(id, this.userId, this.role);
    this.getUserGroups();
  }

  async updateGroups(group) {
    const selectedGroup = group.option.value;
    const options = { userId: this.userId, group: selectedGroup };
    await this.UserApi.addUserToGroup(options, this.role);
    this.myControl.setValue(null);
    this.getUserGroups();
  }

  displayOption(option) {
    return option && option.title ? option.title : '';
  }

  onSubmit() {}
}
